<template>
  <div class="container--mock-analytics-v3">
    <main class="main--mock-analytics-v3">
      <div class="card--mock-analytics-v3">
        <p>
          Este é um mock de conteúdo principal em Vue.js. Substitua por
          gráficos, tabelas ou qualquer componente desejado.
        </p>
      </div>

      <div class="card--mock-analytics-v3">
        <p>
          Este é um mock de conteúdo principal em Vue.js. Substitua por
          gráficos, tabelas ou qualquer componente desejado.
        </p>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'UTM',
}
</script>

<style scoped>
.container--mock-analytics-v3 {
  display: flex;
  flex: 1;
  width: 100%;
  height: 100%;
  background: aqua;
}

.main--mock-analytics-v3 {
  flex: 1;
  overflow: auto;
}

.card--mock-analytics-v3 {
  background: #ffffff;
  border: 1px solid #e5e9f2;
  border-radius: 12px;
  padding: 24px 32px;
  min-height: 600px;
}
</style>
